import { IHelpFulLink } from '../interfaces/IHelpfulLink';

export const HelpfulLinks: IHelpFulLink[] = [
  {
    label: 'Trust Center',
    to: `/trust-center/`,
  },
  {
    label: 'Terms of Use',
    to: `/terms-of-use/`,
  },
  {
    label: 'Cookie Policy',
    to: `/cookie-policy/`,
  },
  {
    label: 'Privacy Policy',
    to: `/privacy/`,
  },
];
